"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonSchemaToView = void 0;
var token_1 = require("./token");
Object.defineProperty(exports, "jsonSchemaToView", { enumerable: true, get: function () { return __importDefault(token_1).default; } });
//# sourceMappingURL=index.js.map